// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".homepage-card{height:100%}", "",{"version":3,"sources":["/home/execapi/backend/app/javascript/panel/pages/HomepageManagement/HomepageManagement.scss"],"names":[],"mappings":"AAAA,eACE,WAAA","file":"HomepageManagement.scss","sourcesContent":[".homepage-card {\n  height: 100%\n}\n"]}]);
// Exports
module.exports = exports;
